<!-- HEADER BANNER -->
<div class="d-flex flex-column flex-md-row align-items-center justify-content-between mt-4 header-banner">
  <div class="float-md-end mx-5 mx-md-0">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/homepage/girl-in-triangle.webp" type="image/webp" />
      <img class="img-fluid" fetchpriority="high" src="https://{{ environment.imagesServer }}/web/homepage/girl-in-triangle.png" alt="Girl Enjoying Contest" width="470" height="416" />
    </picture>
  </div>
  <div>
    <h1 class="mb-2 mt-5 text-center theme-text-title-color"><b>CODE,&nbsp;COMPETE,&nbsp;WIN!</b></h1>
    <h4 class="mb-5 mt-3 text-center">Geared for Coders Ages 8-14</h4>
  </div>
  <div class="d-block float-md-start mx-5 mx-md-0">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/homepage/boy-in-triangle.webp" type="image/webp" />
      <img class="img-fluid" fetchpriority="high" src="https://{{ environment.imagesServer }}/web/homepage/boy-in-triangle.png" alt="Boy Enjoying Contest" width="520" height="416" />
    </picture>
  </div>
</div>

<!-- INTRO & LEADERBOARD -->
<div class="mt-5 fix-row">
  <div class="col-12 col-lg-9 px-5">
    <h2 class="theme-text-header-color">Empowering Young Coders with Frequent Competitions and Global Recognition</h2>
    <p>
      At Code Race&trade;, your child has the opportunity to participate in frequent coding contests, showcasing their skills and competing against talented young coders from around the world. Through our ranking system, young programmers compare themselves to their peers in a global community.
    </p>
    <p>
      Designed to inspire growth at every level, our ranking system works similarly to the Chess ranking system. Each participant’s rank is determined by their performance in the contest and the ranks of their opponents. Coders who perform well against higher-ranked participants will receive a bigger boost to their ranking after the contest. This system not only reflects current skill levels but also tracks improvement as participants climb the ranks.
    </p>
    <p>
      Whether participating in our smaller one-round competitions or larger three-round prize-based contests, Code Race equips coders with the tools to continuously sharpen their skills, build confidence, and have fun along the way!
    </p>
    <p class="fw-bold">Here at Code Race, the quest for coding mastery never stops!</p>
  </div>
  <div class="col-12 col-lg-3 mt-4 mt-lg-2">
    <div class="card mx-5 mx-lg-0 theme-page-bg-color theme-text-color">
      <div class="card-header cwk-pointer pb-2 text-center theme-text-header-color" [routerLink]="['/ranking']"><b>RANKING LEADERBOARD</b></div>
      <!--div class="card-body theme-page-bg-color" *sharedPrerenderOnly>
        <fa-icon [icon]="faSpinner" animation="spin"></fa-icon> Initializing
      </div-->
      <div class="card-body theme-page-bg-color" *sharedNoPrerender>
        @if (isReading && !errorReading) {
          <div><fa-icon [icon]="faSpinner" animation="spin"></fa-icon> Loading</div>
        }
        @if (!isReading && !errorReading) {
          <div class="d-flex">
            <div class="item fs-small position">#</div>
            <div class="item fs-small name">Participant</div>
            <div class="item fs-small age d-none d-sm-block d-lg-none d-xxl-block pe-2">Age</div>
            <div class="item fs-small location d-lg-none d-xl-block ms-auto pe-1">Location</div>
            <div class="item fs-small ms-auto rating">Rating</div>
          </div>
          <hr class="my-1"/>
          @for (ranking of rankings; track ranking.StudentId) {
            <div class="cwk-pointer d-flex ranking-row" (click)="goProfile(ranking.StudentId)">
              <div class="item position">{{ ranking.Position }}</div>
              <div class="item name">{{ ranking.FirstName }}, {{ ranking.LastName.charAt(0) }}.</div>
              <div class="item age d-none d-sm-block d-lg-none d-xxl-block pe-2">{{ ranking.Age }}</div>
              <div class="item location d-lg-none d-xl-block ms-auto pe-1">{{ ranking.Location }}</div>
              <div class="item ms-auto rating">{{ ranking.Ranking }}</div>
            </div>
          }
          @if (!rankings.length) {
            <div>Leaderboard coming soon! Stay tuned!</div>
          }
        }
      </div>
    </div>
  </div>
</div>

<!-- SIGN UP -->
<div class="my-5 text-center">
  <a [routerLink]="['/schedule']">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/homepage/sign-up-today.webp" type="image/webp" />
      <img class="img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/sign-up-today.png" alt="Sign Up Today Button" width="500" height="122" />
    </picture>
  </a>
</div>

<!-- WHY CODE RACE -->
<div class="text-center">
  <h2 class="theme-text-title-color"><b>Why Code Race?</b></h2>
</div>

<div class="fix-row">

  <div class="col-12 col-xl-7">
    <div class="align-items-center align-items-md-start mt-4 fix-row">
      <div class="col-12 col-md-2"></div>
      <div class="col-10 col-md-10 mb-3 mb-md-0 order-2 order-md-1 ps-5 ps-md-2">
        <h3 class="theme-text-header-color">Frequent Competitions for Continuous Improvement</h3>
      </div>
      <div class="col-2 col-md-2 mb-3 mb-md-0 order-1 order-md-2 text-center text-md-end">
        <picture>
          <source srcset="https://{{ environment.imagesServer }}/web/homepage/award-icon.webp" type="image/webp" />
          <img class="icon img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/award-icon.png" alt="Award Icon" width="413" height="384" />
        </picture>
      </div>
      <div class="col-12 col-md-10 order-3">
        Unlike other platforms with only annual events, Code Race offers regular coding contests to keep young coders engaged and continuously improving. Frequent challenges help boost their ranking and power up their progress.
      </div>
    </div>

    <div class="align-items-center align-items-md-start mt-4 fix-row">
      <div class="col-12 col-md-2"></div>
      <div class="col-10 col-md-10 mb-3 mb-md-0 order-2 order-md-1 ps-5 ps-md-2">
        <h3 class="theme-text-header-color">Proven Ranking System for Precise Progress Tracking</h3>
      </div>
      <div class="col-2 col-md-2 mb-3 mb-md-0 order-1 order-md-2 text-center text-md-end">
        <picture>
          <source srcset="https://{{ environment.imagesServer }}/web/homepage/calendar-icon.webp" type="image/webp" />
          <img class="icon img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/calendar-icon.png" alt="Calendar Icon" width="413" height="384" />
        </picture>
      </div>
      <div class="col-12 col-md-10 order-3">
        Code Race utilizes the advanced Bayesian Rating System, a scientifically proven method used in competitive arenas like chess and tennis, where players are compared globally. We’ve adopted this well-tested statistical approach for our coding competitions to ensure accurate and fair comparisons of coders worldwide. With this trusted system, young coders track their progress and rank accurately on the global stage.
      </div>
    </div>

    <div class="align-items-center align-items-md-start mt-4 fix-row">
      <div class="col-12 col-md-2"></div>
      <div class="col-10 col-md-10 mb-3 mb-md-0 order-2 order-md-1 ps-5 ps-md-2">
        <h3 class="theme-text-header-color">Expertly Designed by Coding Education Leaders</h3>
      </div>
      <div class="col-2 col-md-2 mb-3 mb-md-0 order-1 order-md-2 text-center text-md-end">
        <picture>
          <source srcset="https://{{ environment.imagesServer }}/web/homepage/badge-icon.webp" type="image/webp" />
          <img class="icon img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/badge-icon.png" alt="Badge Icon" width="413" height="384" />
        </picture>
      </div>
      <div class="col-12 col-md-10 order-3">
        With over 10 years of experience and 60,000 students served, the team of experts behind Code Race brings award-winning coding education to the competitive world of coding contests, ensuring a fun and effective learning experience.
      </div>
    </div>
  </div>

  <div class="col-12 col-xl-5 p-0 p-md-4">
    <div class="mt-3 mt-md-2">
      <video class="d-block img-fluid w-100" controls poster="https://{{ environment.imagesServer }}/web/homepage/code-race-intro.jpg" width="1024" height="576">
        <source src="https://{{ environment.cfVideoServer }}/code-race-intro.webm" type="video/webm" />
        <source src="https://{{ environment.cfVideoServer }}/code-race-intro.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</div>

<!-- ABOUT THE CONTEST -->
<div class="mt-5 text-center">
  <h2 class="theme-text-title-color"><b>About the Contest</b></h2>
</div>

<div class="fix-row">
  <div class="col-12 col-md-6 px-5">
    <div class="mb-3 mt-4 text-center">
      <picture>
        <source srcset="https://{{ environment.imagesServer }}/web/homepage/code-off-icon.webp" type="image/webp" />
        <img class="icon-big img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/code-off-icon.png" alt="Code Off Icon" width="432" height="480" />
      </picture>
    </div>
    <h3 class="theme-text-header-color">Fast, Fun Challenges</h3>
    Join in for quick, one-round contests as often as every other week. Complete the coding challenge, and get your results instantly! Code-offs happen frequently, helping kids keep their skills sharp and their rankings on the rise.
  </div>
  <div class="col-12 col-md-6 px-5">
    <div class="mb-3 mt-4 text-center">
      <picture>
        <source srcset="https://{{ environment.imagesServer }}/web/homepage/code-cup-icon.webp" type="image/webp" />
        <img class="icon-big img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/code-cup-icon.png" alt="Code Cup Icon" width="432" height="480" />
      </picture>
    </div>
    <h3 class="theme-text-header-color">Epic Tournaments, Exciting Prizes</h3>
    Our multi-round tournaments, held every few months, offer bigger challenges and bigger rewards. Students can advance through the rounds and boost their rankings significantly by competing against peers from around the world.
  </div>
</div>
<!--div class="mt-4 row">
  <div class="col px-5">
    <h3 class="theme-text-header-color">Practice Makes Perfect</h3>
    Need more practice? Mockup competitions are always available to help your child build confidence and refine their coding skills before entering the real contests.
  </div>
</div-->

<!-- SIGN UP -->
<div class="my-5 text-center">
  <a [routerLink]="['/schedule']">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/homepage/sign-up-today.webp" type="image/webp" />
      <img class="img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/sign-up-today.png" alt="Sign Up Today Button" width="500" height="122" />
    </picture>
  </a>
</div>

<!-- SCRATCH & PYTHON -->
<div class="text-center">
  <h2 class="theme-text-title-color"><b>Level Up Your Code</b></h2>
  <h3 class="theme-text-title-color"><b>Compete in Scratch or Python</b></h3>
</div>

<div class="align-items-center mt-4 px-5 fix-row">
  <div class="col-10 col-md-12 order-2 order-md-1 ps-5 ps-md-3">
    <h3 class="theme-text-header-color">Scratch Races</h3>
  </div>
  <div class="col-2 col-md-2 col-xl-1 order-1 order-md-2 text-center text-md-start">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/homepage/scratch-icon.webp" type="image/webp" />
      <img class="icon-small img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/scratch-icon.png" alt="Scratch Icon" width="243" height="243" />
    </picture>
  </div>
  <div class="col-12 col-md-10 col-xl-11 mt-3 mt-md-0 order-3">
    Young coders aged 8-12 can elevate their coding skills by creating dynamic projects with Scratch’s block-based platform. These contests allow young coders to demonstrate their problem-solving abilities in a fun environment, showcasing their creativity and technical skills.
  </div>
</div>

<div class="align-items-center my-4 px-5 fix-row">
  <div class="col-10 col-md-12 order-2 order-md-1 ps-5 ps-md-3">
    <h3 class="theme-text-header-color">Python Races</h3>
  </div>
  <div class="col-2 col-md-2 col-xl-1 order-1 order-md-2 text-center text-md-start">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/homepage/python-icon.webp" type="image/webp" />
      <img class="icon-small img-fluid" src="https://{{ environment.imagesServer }}/web/homepage/python-icon.png" alt="Python Icon" width="243" height="243" />
    </picture>
  </div>
  <div class="col-12 col-md-10 col-xl-11 mt-3 mt-md-0 order-3">
    For those aged 12 and up, as well as advanced 8-12-year-olds looking for a challenge in text-based coding, our Python contests provide the ultimate test. Participants will immerse themselves in programming, crafting sophisticated projects with Python and competing to achieve top rankings.
  </div>
</div>
